export default "__VITE_ASSET__166f8000__"